import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';

var UserSectionPreschool = /*#__PURE__*/function (_Component) {
  _inherits(UserSectionPreschool, _Component);

  var _super = _createSuper(UserSectionPreschool);

  function UserSectionPreschool() {
    _classCallCheck(this, UserSectionPreschool);

    return _super.apply(this, arguments);
  }

  _createClass(UserSectionPreschool, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("table", {
        className: "status-list"
      }, /*#__PURE__*/React.createElement("tbody", null, this.props.section.students.sort(function (a, b) {
        return a.lastName.localeCompare(b.lastName);
      }).map(function (student) {
        return /*#__PURE__*/React.createElement("tr", {
          key: student.id
        }, /*#__PURE__*/React.createElement("td", {
          className: "name"
        }, student.firstName, " ", student.lastName), /*#__PURE__*/React.createElement("td", {
          className: "assessment-bar"
        }));
      }))));
    }
  }]);

  return UserSectionPreschool;
}(Component);

export default UserSectionPreschool;